import { FetchContext } from '../fetch-context';
import { responseErrorHandler } from '../response-error-handler';

export const getUserEORestrictionStatus: (
  fetchContext: FetchContext,
  accessToken?: string,
) => Promise<boolean> = (fetchContext, accessToken) => {
  return fetch(`${fetchContext.baseUrl}/api/compliances/eo-restrictions`, {
    method: 'GET',
    headers: {
      'Authorization': `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    },
  }).then(response => responseErrorHandler<boolean>(fetchContext.errorStore, response, 'get user eo restriction status'));
};
